import SvgInjection from './SvgInjection.svelte';
export class SVGMap {
    constructor(onCommunityClick, onCommunityHover, onCommunityUnhover, focusColor, svgObject, disableColor = "#6E6E6E") {
        this.onCommunityClick = onCommunityClick;
        this.onCommunityHover = onCommunityHover;
        this.onCommunityUnhover = onCommunityUnhover;
        this.focusColor = focusColor;
        this.svgObject = svgObject;
        this.disableColor = disableColor;
        /**
         * The default background colors of the paths with the given id
         * @private
         */
        this.defaultColors = {};
        /**
         * The element that was clicked last.
         * This is used to unset it's background color when clicking another element
         */
        this.lastClicked = null;
        this.listeners = [];
        this.injectedElements = new SvgInjection({
            target: svgObject.contentDocument.firstElementChild,
            anchor: svgObject.contentDocument.firstElementChild.firstElementChild
        });
        this.unsetSize();
        this.initEvents();
    }
    setLastClicked(id) {
        this.setLastClickedElem(this.svgObject.contentDocument.getElementById(id));
    }
    setFills(pathFills) {
        this.defaultColors = pathFills;
        this.iteratePaths(path => {
            this.fillElement(path, pathFills[path.id]);
        });
    }
    markCommunities(markings) {
        this.iteratePaths(path => {
            this.markElement(path, markings[path.id]);
        });
    }
    /**
     * Fills the given communities with the given colors.
     * All other communities are filled with their default color (as specified in the backend by their region)
     * @param fills a map of community ids to fill colors
     */
    fillCommunities(fills) {
        this.iteratePaths(path => {
            this.fillElement(path, fills[path.id] || this.defaultColors[path.id]);
        });
    }
    unsetSize() {
        if (this.svgObject.contentDocument == null || this.svgObject.contentDocument.firstElementChild == null)
            return;
        const svgElement = this.svgObject.contentDocument.firstElementChild;
        svgElement.removeAttribute("width");
        svgElement.removeAttribute("height");
    }
    setLastClickedElem(path) {
        //remove last clicked element's styling
        if (this.lastClicked != null)
            this.markOutline(this.lastClicked, null);
        //style clicked element
        if (path == null)
            return;
        this.markOutline(path, this.focusColor);
        this.raise(path);
        this.lastClicked = path;
    }
    initEvents() {
        this.iteratePaths(path => {
            const id = path.id;
            const listeners = {
                path,
                click: () => {
                    if (path.getAttribute("disabled") == "true")
                        return;
                    this.setLastClickedElem(path);
                    //fire event
                    this.onCommunityClick(id);
                },
                mousemove: (e) => {
                    if (path.getAttribute("disabled") == "true")
                        return;
                    this.onCommunityHover(id, e);
                },
                mouseenter: () => {
                    if (path.getAttribute("disabled") == "true")
                        return;
                    // this.onCommunityHover(id);
                    // this.fillElement(path, this.focusColor); // hover
                    this.markOutline(path, this.focusColor);
                    this.raise(path);
                    if (this.lastClicked) { // make sure the clicked one is always on top
                        this.raise(this.lastClicked);
                    }
                },
                mouseleave: () => {
                    if (path.getAttribute("disabled") == "true")
                        return;
                    this.onCommunityUnhover(id);
                    if (path != this.lastClicked)
                        // 	this.fillElement(path, this.defaultColors[id]); //unhover and not clicked
                        this.markOutline(path, null);
                }
            };
            path.addEventListener('click', listeners.click);
            path.addEventListener('mousemove', listeners.mousemove);
            path.addEventListener('mouseenter', listeners.mouseenter);
            path.addEventListener('mouseleave', listeners.mouseleave);
            this.listeners.push(listeners);
        });
    }
    destroy() {
        this.injectedElements.$destroy();
        for (const listener of this.listeners) {
            listener.path.removeEventListener('click', listener.click);
            listener.path.removeEventListener('mousemove', listener.mousemove);
            listener.path.removeEventListener('mouseenter', listener.mouseenter);
            listener.path.removeEventListener('mouseleave', listener.mouseleave);
        }
    }
    iteratePaths(iteratee) {
        if (this.svgObject == null || this.svgObject.contentDocument == null) {
            console.error("svg document is null", this.svgObject);
            return;
        }
        const paths = this.svgObject.contentDocument.getElementsByTagName("g");
        Array.from(paths).filter(p => p.id !== 'Outline_Rounded_10pt').forEach(path => {
            if (!path.id)
                return;
            iteratee(path);
        });
    }
    fillElement(element, fill) {
        // let backgroundElements: SVGElement[] = []; // Array.from(element.querySelectorAll('.cls-6'))
        // .concat(Array.from(element.querySelectorAll('.st4'))) as SVGElement[]
        // if (element.id == "steinfort") //this one is special
        // 	backgroundElements = [element.children.item(0) as SVGElement, element.children.item(1) as SVGElement];
        // else
        // 	backgroundElements = [element.firstElementChild as SVGElement];
        const backgroundElements = Array.from(element.querySelectorAll('.cls-fill'));
        for (let elem of backgroundElements) {
            if (fill != null)
                elem.style.fill = fill;
            else
                elem.style.fill = this.disableColor;
            // elem.style.fill = '';
            element.setAttribute("disabled", String(fill == null));
        }
    }
    raise(element) {
        const parent = element.parentElement;
        // element.remove();
        parent.appendChild(element);
    }
    /** Makes the outline of the element big and uses the given color. If the color is null, the border is reset */
    markOutline(element, stroke) {
        let backgroundElements = Array.from(element.querySelectorAll('.cls-border'));
        for (let elem of backgroundElements) {
            elem.style.stroke = stroke;
            if (stroke) {
                elem.style.strokeWidth = '10px';
            }
            else {
                elem.style.strokeWidth = '';
            }
        }
    }
    markElement(element, marking) {
        const fillElem = element.querySelector('.cls-fill');
        let markElem = element.querySelector('.cls-mark');
        if (!markElem && marking != null) {
            markElem = fillElem.cloneNode(true);
            markElem.classList.add('cls-mark');
            markElem.classList.remove('cls-fill');
            fillElem.after(markElem);
        }
        if (marking != null) {
            markElem.style.fill = `url(#${marking})`;
        }
        else if (markElem) {
            markElem.remove();
        }
    }
}
